module.exports = "/_next/static/images/3-413d5fc82a2c7c5288cda9df60276ea6.jpg";